module.exports = __webpack_public_path__ + "img/FormsDefaultPhoto.d32b5d81.svg";